import React from 'react';
const links = ['Privacy Policy', 'Terms & Conditions', 'Refund Policy', 'Contact'];
export function Footer() {
  return <footer className="bg-navy-950 px-5 pb-32 pt-10 text-center text-white/60 sm:pb-28" data-id="element-187" data-mp="206rhpe6t9mr6">
      <div className="mx-auto max-w-3xl border-t border-white/10 pt-10" data-id="element-188" data-mp="2f3sazm4nhprr">
        <p className="font-display text-lg font-black uppercase text-white" data-id="element-189" data-mp="2a5797i9r2y17">Maxillary Growth Blueprint™</p>
        <p className="mt-1 text-sm" data-id="element-190" data-mp="1mfml6kyqpal2">
          The Clinical Roadmap for Maxillary Growth Assessment &amp; Dentofacial Development · Dr. Valeria Montes
        </p>
        <nav aria-label="Legal" className="mt-6" data-id="element-191" data-mp="1hf8dj411w2nk">
          <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm" data-id="element-192" data-mp="1w70svg0uhgpa">
            {links.map(link => <li key={link} data-id="element-193" data-mp="1rdo8xj741y2v">
                <a href="#" className="whitespace-nowrap underline-offset-4 transition-colors duration-150 hover:text-white hover:underline" data-id="element-194" data-mp="1rdee9ib4f2qu">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mt-6 text-xs leading-relaxed" data-id="element-195" data-mp="1eh0zx8ry3d04">
          <strong className="text-white/80" data-id="element-196" data-mp="1eg9akfoxybia">Educational Disclaimer:</strong> This collection is intended for
          professional education and reference. It does not constitute individualized medical or dental advice, replace
          accredited clinical training, or guarantee diagnostic accuracy or treatment outcomes. Clinical decisions must
          be based on appropriate patient-specific assessment, current scientific evidence, professional judgment, and
          applicable standards of care.
        </p>
        <p className="mt-4 text-xs" data-id="element-197" data-mp="14k644xn23qpj">© 2026 MAXILLARY GROWTH BLUEPRINT™. All rights reserved.</p>
      </div>
    </footer>;
}